import React from 'react';

const ComponentLoading = ({error}) => {
  return (
    <div>{error ? 'Oh nooess!' : <span />}</div>
  )
}

export default ComponentLoading;